module.exports = __webpack_public_path__ + "static/media/cart.de1d3c03.svg";